export default function CaseResults() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="cases" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Реальные результаты клиентов
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Результаты достигаются благодаря сочетанию обучения, практики и сопровождения. Каждый кейс — реальная компания с измеримыми показателями.
          </p>
        </div>

        <div className="space-y-8 max-w-4xl mx-auto">
          {/* Case 1 */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-building-4-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">Агентство недвижимости</h3>
                <p className="text-gray-500 text-sm">Холодные звонки, B2C</p>
              </div>
            </div>
            <div className="bg-teal-50 rounded-xl p-6 mb-6 text-center">
              <div className="text-4xl font-extrabold text-teal-600 mb-2">&times;2</div>
              <p className="text-base text-gray-700">рост количества договоров по холодным звонкам</p>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Серия бизнес-игр и практикумов по холодным звонкам</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Прослушивание и разбор реальных звонков агентов</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Сопровождение внедрения новых подходов</p>
            </div>
          </div>

          {/* Case 2 */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-ship-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">Международная логистическая компания</h3>
                <p className="text-gray-500 text-sm">B2B, комплексное обучение и сопровождение</p>
              </div>
            </div>
            <div className="bg-teal-50 rounded-xl p-6 mb-6 text-center">
              <div className="text-4xl font-extrabold text-teal-600 mb-2">18–23%</div>
              <p className="text-base text-gray-700">рост конверсии отдела продаж месяц к месяцу</p>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Аудит 80+ записей холодных звонков</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>Разработана система скриптов под сегменты клиентов</p>
              <p><i className="ri-check-line text-teal-600 mr-2"></i>3-месячное сопровождение с разбором сложных кейсов</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Хочу такой же результат
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}